<div class="user-managment-filtering-options">
  <div class="row">
      <div class="col-md-6">
      </div>
      <div class="col-md-6">
          <div class="filter-by-name-option">
              <div class="form-group">
                  <mat-form-field>
                      <input
                          placeholder="Search by User Name"
                          matInput
                          [(ngModel)]="searchByName"
                          name="search"
                          #search="ngModel"
                      >
                      <mat-icon matSuffix>search</mat-icon>
                  </mat-form-field>
              </div>
          </div>
      </div>
  </div>
  <div class="user-management-heading-info">
      <div class="align-h width-stretch">
          <div class="stretch">Name</div>
          <div class="stretch">Employee ID</div>
          <div class="stretch">Mobile No</div>
          <div class="width-200 margin-right-10"></div>
      </div>
  </div>
  <mat-accordion>
      <mat-expansion-panel
          *ngFor="let user of userList| searchFilter: ['name']:searchByName"
          class="margin-bottom-20"
          (opened)="panelMap[user?.id] = true"
          (closed)="panelMap[user?.id] = false"
      >
          <mat-expansion-panel-header>
              <div class="align-h width-stretch">
                  <div class="stretch">
                      <div>{{ user.name }}</div>
                      <ng-template [ngIf]="user.isDeleted">
                        <div class="user-deleted-text">Deleted</div>
                      </ng-template>
                </div>
                  <div class="stretch">{{ user.userId }}</div>
                  <div class="stretch">{{ user.mobile }}</div>
                  <div class="align-h width-215">
                      <ng-template [ngIf]="panelMap[user?.id]">
                          <div class="stretch">
                            <ng-template [ngIf]="!user?.isDeleted">
                                <a
                                mat-flat-button
                                (click)="$event.stopPropagation();onEditUser(user)"
                                >
                                <img
                                    src="assets/images/Edit.png"
                                    alt="Edit"
                                >
                                </a>
                            </ng-template>
                          </div>
                          <div class="stretch">
                            <ng-template [ngIf]="!user?.isDeleted">
                                <a
                                    mat-flat-button
                                    (click)="$event.stopPropagation();openDeleteDialog(user)"
                                >
                                    <img
                                        src="assets/images/Delete.png"
                                        alt="Delete"
                                    >
                                </a>
                              </ng-template>
                          </div>
                          <div class="stretch">
                            <ng-template [ngIf]="!user?.isDeleted">
                                <button  mat-icon-button [color]="user?.isBlocked ? 'primary': 'secondary'" (click)="openBlockDialog(user)">
                                    <mat-icon>block</mat-icon>
                                </button>
                            </ng-template>
                          </div>
                      </ng-template>
                  </div>
              </div>
          </mat-expansion-panel-header>


          <div class="align-h width-stretch">
              <div class="stretch">Email ID: {{ user.email }}</div>
              <div class="stretch">Region: {{ user.regionName }}</div>
              <div class="stretch">Department: {{ user.departmentName }}</div>
          </div>
          <div class="align-h width-stretch margin-top-25">
              <div class="stretch">Role: {{ user.roleName }}</div>
          </div>
          <div class="align-h width-stretch-150 margin-top-25 margin-bottom-20">
              <div class="stretch user-permission-font-16">
                  Has Access To:
                  <span class="comma-separated-list">
                      <ng-template
                          ngFor
                          let-feature
                          [ngForOf]="user?.feature"
                      >
                          <span>{{ feature?.fName }}</span>
                      </ng-template>
                  </span>
              </div>
              <div class="stretch">
                  <button
                      mat-raised-button
                      color="primary"
                      class="mat-button-medium"
                      type="submit"
                      (click)="resetPassword(user)"
                      [disabled]="user.isBlocked || user.isDeleted"
                  >
                      Reset Password
                  </button>
              </div>
          </div>
      </mat-expansion-panel>
      <div class="no-data" *ngIf="(userList | searchFilter:['name']:searchByName)?.length === 0 ">No data found!!!</div>
  </mat-accordion>
</div>
